import ng from "angular";
import { IGastronomicProposalModel, IGastronomicProposalObject } from "../../models/gastronomic-proposal.model";
import { IbGastronomicProposalService } from "../../services/ib-gastronomic-proposal.service";
import { IbGastronomicProposalUtilsService } from "../../services/ib-gastronomic-proposal-utils.service";
import { IbDigitalMenuService } from "../../services/ib-digital-menu.service";
import { IOverlayModalStatus } from "../../models/digital-menu.model";

@Controller('ib-MmB-gastronomic-proposal-module', ['$uibModalInstance', 'object', 'CommonsModalService', 'IbGastronomicProposalService', 'IbGastronomicProposalUtilsService', 'IbDigitalMenuService'], [])
export class IbGastronomicProposalModalController implements ng.IController {

    gastronomicProposalModel: IGastronomicProposalModel;
    overLayModalStatus: IOverlayModalStatus = {
        showError: false,
        showLoading: false,
        errorData: []
    };

    constructor(private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private object: IGastronomicProposalObject,
        private commonsModalService: CommonsModalService,
        private ibGastronomicProposalService: IbGastronomicProposalService,
        private ibGastronomicProposalUtils: IbGastronomicProposalUtilsService,
        private ibDigitalMenuService: IbDigitalMenuService) {
        this.ibGastronomicProposalUtils.closeAll$.subscribe(() => this.close());
        this.ibDigitalMenuService.overlayModalStatus$.subscribe(response => this.overLayModalStatus = { ...response });
    }

    active = (): any => {
        this.gastronomicProposalModel = this.ibGastronomicProposalService.generateGastroProposalModel(this.object);
    };

    close() {
        this.$uibModalInstance.close();
    }

    closeOverlayModal() {
        this.overLayModalStatus.showError = false;
        this.overLayModalStatus.showLoading = false;
    }

    openWarningModal() {
        const modelObject = { ... this.object };
        this.commonsModalService.showGenericDynamicModal(
            false,
            'ib-pre-selection-warning-modal.html',
            modelObject,
            'IbGastronomicProposalModalController',
            'ib-modals fade'
        );
    }

    $onInit = this.active();
}
